export default class TaskProductHistory {
    static searchConfig = [
        {
            'icon': 'mdi-clipboard-outline',
            'label': 'Workflow',
            'type': 'module',
            'settings': {
                'module': 'taskTypes',
                'fields': ['name'],
                'title': '{name}',
            },
            'filter': 'taskTypeId'
        },
        {
            'icon': 'mdi-folder-open-outline',
            'label': 'Project',
            'type': 'module',
            'settings': {
                'module': 'projects',
                'fields': ['name', 'description'],
                'title': '{name} ({description})',
            },

            'filter': 'projectId'
        },
        {
            'icon': 'mdi-folder-open-outline',
            'label': 'Asset',
            'type': 'module',
            'settings': {
                'module': 'products',
                'fields': ['name', 'description'],
                'title': '{name} ({description})',
            },

            'filter': 'productId'
        },
        {
            'icon': 'mdi-office-building-outline',
            'label': 'Bedrijf',
            'type': 'module',
            'settings': {
                'module': 'companies',
                'fields': ['name', 'description'],
                'title': '{name} ({description})',
            },

            'filter': 'companyId'
        },
        {
            'icon': 'mdi-tag-outline',
            'label': 'Status',
            'type': 'options',
            'settings': {
                'options': (settings) => {
                    return settings.statusCodes;
                }
            },
            'filter': 'statusCode'
        },
        {
            'icon': 'mdi-alarm',
            'label': 'Van',
            'type': 'date-between',
            'filter': 'dueAfterDate'
        },
        {
            icon: 'mdi-calendar',
            label: 'Tot',
            type: 'date-between',
            filter: 'dueBeforeDate'
        },
    ];
}